import React, {CSSProperties} from "react";
import {observer} from "mobx-react";
import {IFeeViewModel} from "../../../services/booking/models/base-models/fees/fee-view-model.interface";
import {useServices} from "../../../hooks/use-services.hook";


const TicketFeeComponent: React.FC<{fee: IFeeViewModel; isLastOne: boolean}> = observer((props) => {
    const services = useServices();
    const theme = services.theme.currentTheme;

    const styles: CSSProperties = {
        display: 'grid',
        gridTemplateColumns: '1fr auto 1fr',
        alignItems: 'center',
        width: '100%',
        pageBreakInside: 'avoid',
        breakInside: 'avoid'
    }

    if(!props.isLastOne) {
        styles.borderBottom = `1px solid ${theme.border.mainColor}`;
        styles.paddingBottom = theme.spacing.flexGap12;
    }

    return (
        <div style={styles}>
            <div>
                {props.fee.description}
            </div>
            <div style={{justifySelf: 'flex-end'}}>
                {`${props.fee.quantity} x ${props.fee.priceToDisplay.toString()}`}
            </div>
            <div style={{justifySelf: 'flex-end'}}>
                {props.fee.totalToDisplay.toString()}
            </div>
        </div>
    )
})

interface TicketJourneyServicesFeesComponentProps {
    fees: IFeeViewModel[];
}
export const TicketFeesComponent: React.FC<TicketJourneyServicesFeesComponentProps> = observer((props) => {
    const services = useServices();
    const theme = services.theme.currentTheme;

    if(props.fees.length === 0) {
        return null;
    }

    const rootStyle: CSSProperties = {
        display: "flex",
        flexDirection: "column",
        gap: theme.spacing.flexGap12,
        width: '100%',
        padding: theme.spacing.cardDefaultPadding,
        border: `1px solid ${theme.border.mainColor}`,
        borderRadius: theme.border.defaultRadius
    }

    return (
        <div style={rootStyle}>
            {props.fees.map((f, index) => <TicketFeeComponent key={f.feeGroupKey} fee={f} isLastOne={index === props.fees.length - 1}/>)}
        </div>
    )
})